import {ICellRenderer} from 'ag-grid-community';
import {Tooltip} from 'platform/components';

import {forwardRef} from 'react';

import {useTooltipProps} from '../../hooks/useTooltipProps';
import {ICellRendererParams} from '../../types/AgGridTypes';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getCellClassName} from '../../utils/getCellClassName';
import {getValueToRender} from '../../utils/getValueToRender';

export interface PlainCellRendererProps extends ICellRendererParams {
  getTooltipProps?: TooltipGetter;
}

function PlainCellRendererComponent(props: PlainCellRendererProps, _ref: React.Ref<ICellRenderer>) {
  const {getTooltipProps, data, node, colDef} = props;
  const className = getCellClassName(colDef);
  const cellValue = getValueToRender(props);

  const tooltipProps = useTooltipProps(data, node, getTooltipProps);

  return (
    <Tooltip {...tooltipProps}>
      {/* eslint-disable-next-line react/forbid-dom-props */}
      <div className={className}>{cellValue}</div>
    </Tooltip>
  );
}

export const PlainCellRenderer = forwardRef<ICellRenderer, PlainCellRendererProps>(
  PlainCellRendererComponent
);
